// ============================================================================
// CONGOLESE (LINGALA) BIBLE PASSAGES
// ============================================================================
// Makomi ya Biblia na Lingala na mituya ya Strong

export const biblePassagesRc = {
  "Ebandeli_1": {
    book: "Ebandeli",
    chapter: 1,
    title: "Bokeli ya Mokili",
    verses: [
      { number: 1, text: "Na ebandeli, Nzambe akela likolo mpe mabele", strong: ["H7225", "H430", "H1254"] },
      { number: 2, text: "Mabele ezalaki mpamba mpe ezalaki na eloko moko te, molili ezalaki likolo ya mai, mpe Molimo ya Nzambe ezalaki kopumbwa likolo ya mai", strong: ["H776", "H8414", "H7307"] },
      { number: 3, text: "Nzambe alobaki: Tika ete pole ezala, mpe pole ezalaki", strong: ["H430", "H559", "H216"] },
      { number: 4, text: "Nzambe amonaki ete pole ezali malamu. Nzambe akabolaki pole na molili", strong: ["H430", "H7200", "H216", "H2896"] },
      { number: 5, text: "Nzambe abengaki pole moyi, mpe molili abengaki yango butu. Mpokwa ezalaki mpe ntongo ezalaki, mokolo ya liboso", strong: ["H430", "H7121", "H3117", "H3915"] },
      { number: 6, text: "Nzambe alobaki: Tika ete likolo ezala kati na mai, mpe ekabola mai na mai", strong: ["H430", "H7549", "H4325"] },
      { number: 7, text: "Nzambe asalaki likolo, mpe akabolaki mai oyo ezali na nse ya likolo na mai oyo ezali likolo ya likolo. Mpe ezalaki bongo", strong: ["H430", "H6213", "H7549"] },
      { number: 8, text: "Nzambe abengaki likolo likoló. Mpokwa ezalaki mpe ntongo ezalaki, mokolo ya mibale", strong: ["H430", "H7121", "H8064"] },
      { number: 27, text: "Nzambe akela moto na elilingi na Ye moko, na elilingi ya Nzambe akela ye, akela bango mobali mpe mwasi", strong: ["H430", "H1254", "H120", "H6754"] },
      { number: 31, text: "Nzambe amonaki makambo nyonso oyo asalaki, mpe tala, ezalaki malamu mpenza. Mpokwa ezalaki mpe ntongo ezalaki, mokolo ya motoba", strong: ["H430", "H7200", "H2896", "H3966"] }
    ]
  },
  "Banzembo_23": {
    book: "Banzembo",
    chapter: 23,
    title: "Yawe Mobateli na ngai",
    verses: [
      { number: 1, text: "Yawe azali Mobateli na ngai, nakozanga eloko te", strong: ["H3068", "H7462", "H2637"] },
      { number: 2, text: "Apumbisaka ngai na matiti ya mobesu, amemaka ngai na ebale ya kimia", strong: ["H7257", "H4999", "H5148", "H4325"] },
      { number: 3, text: "Azongisaka molimo na ngai, atambolisaka ngai na nzela ya bosembo mpo na nkombo na Ye", strong: ["H7725", "H5315", "H5148", "H6664"] },
      { number: 4, text: "Ata soki natamboli na lubwaku ya molili ya liwa, nakobanga mabe te, pamba te ozali elongo na ngai, lingenda na Yo mpe nkonga na Yo ezali kobondisa ngai", strong: ["H1980", "H1516", "H6757", "H3372", "H7626"] },
      { number: 5, text: "Obongiseli ngai mesa liboso ya banguna na ngai, opakoli mafuta na moto na ngai, kopo na ngai etondi", strong: ["H6186", "H7979", "H6887", "H1878", "H3563"] },
      { number: 6, text: "Solo, bolamu mpe bolingo ekolanda ngai mikolo nyonso ya bomoi na ngai, mpe nakovanda na ndako ya Yawe mpo na libela", strong: ["H2896", "H2617", "H7291", "H3117", "H1004", "H3068"] }
    ]
  },
  "Yoane_3": {
    book: "Yoane",
    chapter: 3,
    title: "Yesu na Nikodemo",
    verses: [
      { number: 16, text: "Pamba te Nzambe alingaki mokili boye ate apesaki Mwana na Ye ya moko, mpo ete moto nyonso oyo akondima na Ye abeba te, kasi azala na bomoi ya seko", strong: ["G2316", "G25", "G2889", "G1325", "G5207"] },
      { number: 17, text: "Pamba te Nzambe atindaki Mwana na Ye na mokili te mpo na kosambisa mokili, kasi mpo ete mokili ebikisama na nzela na Ye", strong: ["G2316", "G649", "G2889", "G2919", "G4982"] },
      { number: 18, text: "Oyo andimi na Ye azali kosambisama te, kasi oyo andimi te asambisami na sik'oyo, pamba te andimi te na nkombo ya Mwana ya moko ya Nzambe", strong: ["G4100", "G2919", "G3686", "G5207", "G2316"] }
    ]
  },
  "Bafilipo_4": {
    book: "Bafilipo",
    chapter: 4,
    title: "Kimia ya Nzambe",
    verses: [
      { number: 4, text: "Bosepela tango nyonso na Nkolo, nakolobela lisusu: Bosepela", strong: ["G5463", "G2962", "G3825"] },
      { number: 6, text: "Bomitungisa te na eloko moko te, kasi na makambo nyonso, na libondeli mpe na kobondela, na botondi, bosengela bino etalisama epai ya Nzambe", strong: ["G3309", "G4335", "G1162", "G2169"] },
      { number: 7, text: "Mpe kimia ya Nzambe oyo eleki bososoli nyonso, ekobatela mitema mpe makanisi na bino na Klisto Yesu", strong: ["G1515", "G2316", "G5242", "G3563", "G5432"] },
      { number: 13, text: "Nakoki kosala makambo nyonso na nzela ya Klisto oyo azali kopesa ngai makasi", strong: ["G1411", "G1743", "G5547"] }
    ]
  }
};

export default biblePassagesRc;
